import { gatewayApiService } from "./gateway-service";
import { ACTIVITY_SERVICE_PATH } from "@/config";


/**
 * Activity-specific API service that routes requests to the activity service
 * This is a wrapper around gatewayApiService with the activity service path pre-configured
 */
interface ActivityApiServiceInt {
  requestData?: Record<string, unknown> | FormData | string | null;
  url: string;
  method: "get" | "put" | "post" | "patch" | "delete";
  protectedRoute?: boolean;
  params?: Record<string, unknown>;
  headers?: Record<string, string>;
  responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
  timeout?: number;
}

/**
 * API service specifically for activity-related endpoints
 * Routes all requests through the API gateway to the activity service
 */
export const activityApiService = async ({
  requestData,
  url,
  method,
  protectedRoute = false,
  params,
  headers,
  responseType,
  timeout,
}: ActivityApiServiceInt) => {
  return gatewayApiService({
    requestData,
    url,
    method,
    protectedRoute,
    params,
    headers,
    responseType,
    timeout,
    servicePath: ACTIVITY_SERVICE_PATH, // Use activity service path
  });
};
